import React from "react";

const Footer = () => {
    return (
        <footer className="footerStyle">
            <div className="containerStyle">
                <p>© 2024 WhisperWall. All rights reserved.</p>
                <p>Developed by Shubham Sehra</p>
                <div className="linksStyle">
                    <a href="https://www.linkedin.com/in/shubhamsehra">LinkedIn</a>
                    <a href="https://github.com/shubhamsehra">GitHub</a>
                    <a href="mailto:shubh9414@gmail.com">Contact</a>
                </div>
            </div>
        </footer>
    );
};




export default Footer;
